let solicitorDetail = '';
let name = '';
let url = '';
let email = '';
let resetPasswordToken = '';

export const setSolicitorDetail = (s: string) => {
    solicitorDetail = s;
};

export const getSolicitorDetail = () => {
    return solicitorDetail;
};


export const setName = (s: string) => {
    name = s;
};

export const getName = () => {
    return name;
};

export const setEmail = (s: string) => {
    email = s;
};

export const getEmail = () => {
    return email;
};

export const setResetPasswordToken = (s: string) => {
    resetPasswordToken = s;
};

export const getResetPasswordToken = () => {
    return resetPasswordToken;
};

export const setUrl = (s: string) => {
    url = s;
};

export const getUrl = () => {
    return url;
};

export const reset = () => {
    solicitorDetail = ''
    name = ''
    url = ''
}